/**
 * قیمت‌ها از سمت سرور همیشه به ریال می‌آیند (تنظیم currency پروژه = 2) ولی
 * تمام رابط کاربری ژومنت باید تومان نشان بدهد.
 *
 * تبدیل فقط لایه‌ی نمایش است: هر عددی که به API برمی‌گردد (سبد خرید، درگاه
 * پرداخت، فیلتر قیمت) باید ریال بماند، پس قبل از ارسال با `to_rial` برگردانده
 * می‌شود.
 */

export const RIAL_PER_TOMAN = 10;

export const CURRENCY_LABEL = "تومان";

/** ریالِ آمده از API → تومانِ قابل نمایش */
export const to_toman = (rial) => {
	const value = Number(rial);
	if (!Number.isFinite(value)) return 0;
	return value / RIAL_PER_TOMAN;
};

/** تومانِ وارد شده توسط کاربر → ریالی که API انتظار دارد */
export const to_rial = (toman) => {
	const value = Number(toman);
	if (!Number.isFinite(value)) return 0;
	return Math.round(value * RIAL_PER_TOMAN);
};
